import { RootState } from 'app/store';

export const selectPageTitle = (state: RootState) => state.pageTitle.title;
